

export default {
  state: {
    code: ''
  },
  mutations: {
    setCode: (state, code) => {
      state.code = code
    }
  },
  getters: {
    code: state => {
      return state.code
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/detail.js